import { RootState } from 'store';

const Suppliers = (state: RootState) => state.supportAtHome.suppliers;

export const selectSuppliers = (state: RootState) => Suppliers(state).rows;
export const selectSuppliersTotal = (state: RootState) => Suppliers(state).total;
